import { useTranslation } from 'react-i18next';

import { clearThemeStorage, LogoutOutline } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';
import { clearTokenFromStorage } from '@bonusly/who-am-i';

import { resetGlobalSyncState } from '../../../../hooks/use-user-color-mode-with-sync';
import { Route } from '../../config/router';
import { NavMenuItem } from '../Navigation/NavMenuItem';

const AuthButton = () => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('navigation');

	const handleLogoutClick = () => {
		// Clear widget JWT cookie before logout to prevent stale authentication
		clearTokenFromStorage();
		// Clear theme localStorage to prevent theme settings from persisting
		// across different user accounts on the same browser
		clearThemeStorage();
		// Reset the global sync state so the next user's preferences will be synced
		resetGlobalSyncState();
	};

	return (
		<NavMenuItem to={recognizeURL(Route.Logout)} icon={<LogoutOutline />} onClick={handleLogoutClick}>
			{t('user_menu.log_out')}
		</NavMenuItem>
	);
};

export default AuthButton;
